/**
 * @file _common.js
 */
'use strict';
import swal from 'sweetalert2';

/**
 * @classname Common
 */

export default class Common {


	/**
	 * ゼロパディングする
	 *
	 * @memberof Common
	 * @param {int} num - 元の数字
	 * @param {int} length - 桁数
	 * @return {string} - ゼロパディングした数字
	 */
	static zeroPadding(num, length) {
		return ('0000000000' + num).slice(-length);
	};


	/**
	 * 数字をカンマ区切りにする
	 *
	 * @memberof Common
	 * @param {string} num - 3桁区切りの数字
	 * @return {string} - カンマを削除した数字
	 */
	static separatedByComma(num) {
		return Number(num).toLocaleString();
	};


	/**
	 * 日時を取得する
	 *
	 * @memberof Common
	 * @param {date} date - 日時
	 * @return {date} date - 現在日時
	 */
	static getCurrentDateTime(date) {
		(date) ? new Date(date) : new Date();
		date =
			date.getFullYear() + '-' +
			this.zeroPadding(date.getMonth() + 1, 2) + '-' +
			this.zeroPadding(date.getDate(),2) + ' ' +
			this.zeroPadding(date.getHours(), 2) + ':' +
			this.zeroPadding(date.getMinutes(), 2) + ':' +
			this.zeroPadding(date.getSeconds(), 2);
		return date;
	};



	/**
	 * 本日の日付を取得する
	 *
	 * @memberof Common
	 * @return {date} date - 現在日時
	 */
	static getCurrentDate() {
		let date = new Date();
		date =
			date.getFullYear() + '-' +
			this.zeroPadding(date.getMonth() + 1, 2) + '-' +
			this.zeroPadding(date.getDate(),2) ;
		return date;
	};


	/**
	 * パラメーターなしのURLを取得する
	 *
	 * @memberof Common
	 * @return {string} url - パラメーターなしのURL
	 */
	static getCurrentURL() {
		let url = document.location.href;
		if (url.match(/\?/)) {
			url = RegExp.leftContext;
		} else if (url.match(/#/)) {
			url = RegExp.leftContext;
		}
		return url;
	};


	/**
	 * URLパラメーターを取得する
	 *
	 * @memberof Common
	 * @return {array} param - URLパラメーター key value
	 */
	static getParam() {
		let url = document.location.href;
		if (url.match(/(.+)#/)) {
			const match1 = url.match(/(.+)#/);
			url = match1[1];
		}
		let params = null;
		if (url.match(/\?(.+)$/)) {
			const match2 = url.match(/\?(.+)$/)
			params = match2[1];
		} else {
			return {};
		}
		let tmp = params.split('&');
		let param = {};
		let tmp2, key, val;
		for (let i = 0; i < tmp.length; i++) {
			// initialize
			tmp2 = [];
			key = '';
			val = '';

			tmp2 = tmp[i].split('=');
			key = tmp2[0];
			val = tmp2[1];
			param[key] = val;
		}
		return param;
	};


	/**
	 * パラメーターを文字列で取得する
	 *
	 * @memberof Common
	 * @return {string} url - パラメーターなしのURL
	 */
	static getParamAll() {
		let url = document.location.href;
		if (url.match(/\?/)) {
			let param = RegExp.rightContext;
		}
		return param;
	};


	/**
	 * エラーモーダルを表示する
	 *
	 * @memberof Common
	 * @return {string} msg - 表示するメッセージ
	 */
	static showErrorModal(msg) {
		swal({
			title: 'エラー',
			html: msg,
			type: 'error',
			confirmButtonColor: '#d33'
		});
	};


	/**
	 * フォームの送信をする
	 *
	 * @memberof Common
	 */
	static submit($form) {
		if($form.attr('action') === '#' || $form.attr('action') === ''){
			this.showDummySubmit();
		}else{
			$form.submit();
		}
	};


	/**
	 * ダミーのフォーム送信モーダルを表示する
	 *
	 * @memberof Common
	 */
	static showDummySubmit() {
		swal({
			title: 'フォーム送信完了',
			html:
				'actionに値を設定するとフォームが送信されます。<br>' +
				'実際のjavascript処理は正常に完了しています。',
			type: 'info'
		});
	};


	/**
	 * 配列から重複なく複数の値を取り出す
	 *
	 * @memberof Common
	 * @return {array / string} r - 配列の値
	 */
	static getRandomFromArray(array, num, isString) {
		let a = array;
		let t = [];
		let r = [];
		let l = a.length;
		let n = num < l ? num : l;
		while (n-- > 0) {
			let i = Math.random() * l | 0;
			r[n] = t[i] || a[i];
			--l;
			t[i] = t[l] || a[l];
		}
		if(isString){
			return r.toString();
		}else{
			return r;
		}
	};


	/**
	 * 機種判定を行う
	 *
	 * @memberof Common
	 * @return {undefined}
	 */
	static addHtmlClass() {
		let ua = window.navigator.userAgent.toLowerCase();
		let ver = window.navigator.appVersion.toLowerCase();

		// check browser
		let browser, device;
		if (ua.indexOf('edge') !== -1){
			browser = 'edge';
		} else if (ua.indexOf("iemobile") !== -1) {
			browser = 'iemobile';
		} else if (ua.indexOf('trident/7') !== -1) {
			browser =  'ie11';
		} else if (ua.indexOf("msie") !== -1 && ua.indexOf('opera') === -1){
			if(ver.indexOf("msie 6.")  !== -1) {
				browser = 'ie6';
			} else if (ver.indexOf("msie 7.")  !== -1) {
				browser = 'ie7';
			} else if (ver.indexOf("msie 8.")  !== -1) {
				browser = 'ie8';
			} else if (ver.indexOf("msie 9.")  !== -1) {
				browser = 'ie9';
			} else if (ver.indexOf("msie 10.") !== -1) {
				browser = 'ie10';
			}
		} else if (ua.indexOf('chrome')  !== -1 && ua.indexOf('edge') === -1) {
			browser =  'chrome';
		} else if (ua.indexOf('safari')  !== -1 && ua.indexOf('chrome') === -1) {
			browser =  'safari';
		} else if (ua.indexOf('opera')   !== -1) {
			browser = 'opera';
		} else if (ua.indexOf('firefox') !== -1) {
			browser = 'firefox';
		}

		// check device
		if(ua.indexOf('iphone') !== -1 || ua.indexOf('ipod') !== -1 ) {
			device = 'iphone';
		} else if (ua.indexOf('ipad')    !== -1) {
			device = 'ipad';
		} else if (ua.indexOf('android') !== -1) {
			device = 'android';
		} else if (ua.indexOf('windows') !== -1 && ua.indexOf('phone') !== -1) {
			device = 'windows_phone';
		}

		if(browser) $('html').addClass(browser);
		if(device) $('html').addClass(device);
	}

	/**
	 * loadingアイコンを表示する
	 *
	 * @memberof Common
	 * @return {undefined}
	 */
	static showLoading() {
		const loading = '<div id="loading"><img src="/img/spinner.svg" width="100" height="100"></div>';
		$('body').append(loading);
	}

	/**
	 * loadingアイコンを消去
	 *
	 * @memberof Common
	 * @return {undefined}
	 */
	static hideLoading() {
		$('#loading').remove();
	}

}
